import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { getContainerStyles } from '@/utils';
import { useThemeMode } from '@/context';
export const useStyles = () => {
  const { theme } = useTheme();
  const { isDark } = useThemeMode();
  return useMemo(
    () => ({
      wrapper: css`
        width: ${theme.spacing.get('100%')};
        background-color: var(--common-color);
      `,

      container: css`
        ${getContainerStyles(theme)};
        ${responsive.create({
          paddingTop: {
            default: theme.spacing.get(56),
            md: theme.spacing.get(72),
            lg: theme.spacing.get(100),
          },
          paddingBottom: {
            default: theme.spacing.get(56),
            md: theme.spacing.get(70),
            lg: theme.spacing.get(100),
          },
        })}
      `,

      title: css`
        font-weight: ${theme.fonts.weight.medium};
        color: #f5f6fa;
        color: var(--text-color);
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xl}`,
            md: `${theme.fonts.size.xxl}`,
            lg: `${theme.fonts.size['4xl']}`,
          },
        })}
      `,

      description: css`
        max-width: 680px;
        text-align: center;
        color: var(--desc-text-color);

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.md}`,
            lg: `${theme.fonts.size.xl}`,
          },
        })}
      `,

      headerSection: css`
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(52),
            md: theme.spacing.get(92),
            lg: theme.spacing.get(132),
          },
        })}
      `,

      box: css`
        max-width: 448px;
        ${responsive.create({
          padding: {
            default: '16px',
            md: '24px',
            lg: '32px',
          },
        })}

        background-color: var(--common-color);
        border-color: var(--border-color);
        transition: border-color 0.3s ease;
      `,

      steplabel: css`
        color: var(--brand-color);
        font-weight: ${theme.fonts.weight.medium};
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(8),
            md: theme.spacing.get(8),
            lg: theme.spacing.get(12),
          },
        })}
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xxs}`,
            md: `${theme.fonts.size.xs}`,
            lg: `${theme.fonts.size.lg}`,
          },
        })}
      `,

      stepTitle: css`
        color: var(--text-color);
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(4),
            md: theme.spacing.get(4),
            lg: theme.spacing.get(8),
          },
        })}
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.lg}`,
            lg: `${theme.fonts.size.xxl}`,
          },
        })}
      `,

      stepDescription: css`
        color: var(--desc-text-color);
        font-size: ${theme.fonts.size.lg};
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xs}`,
            md: `${theme.fonts.size.xs}`,
            lg: `${theme.fonts.size.lg}`,
          },
        })}
      `,

      secondarySteplabel: css`
        color: var(--brand-color);
        font-weight: ${theme.fonts.weight.medium};
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(4),
            md: theme.spacing.get(4),
            lg: theme.spacing.get(8),
          },
        })}
        font-style: italic;

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xxs}`,
            md: `${theme.fonts.size.xs}`,
            lg: `${theme.fonts.size.lg}`,
          },
        })}
      `,
    }),
    [theme],
  );
};
